// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ══════════════════════════════════════════════════════════════════════════════
   AI Loading Animation
   Colors driven by CSS custom properties set per group in the component.
   ══════════════════════════════════════════════════════════════════════════════ */

/* ── Overlay ────────────────────────────────────────────────────────────────── */
.ai-loading-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  overflow: hidden;
  animation: overlayIn 0.4s ease-out;
}

/* Central glow */
.ai-loading-overlay::before {
  content: '';
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translateX(-50%);
  width: 520px;
  height: 520px;
  background: radial-gradient(circle, var(--glow) 0%, transparent 70%);
  pointer-events: none;
}

@keyframes overlayIn {
  from { opacity: 0; }
  to   { opacity: 1; }
}

/* ── Floating bubbles ───────────────────────────────────────────────────────── */
.bubble {
  position: absolute;
  bottom: -20px;
  border-radius: 50%;
  background: var(--bubble-bg);
  border: 1px solid var(--bubble-border);
  animation: bubbleRise linear infinite;
  pointer-events: none;
}

@keyframes bubbleRise {
  0%   { transform: translateY(0)      scale(1);   opacity: 0.7; }
  40%  { transform: translateY(-35vh)  scale(1.1); opacity: 0.4; }
  100% { transform: translateY(-100vh) scale(0.7); opacity: 0;   }
}

/* ── Main container ─────────────────────────────────────────────────────────── */
.ai-loading-container {
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 20px 24px 110px;
  max-width: 460px;
  width: 100%;
}

/* ── Scene ──────────────────────────────────────────────────────────────────── */
.scene {
  position: relative;
  width: 260px;
  height: 260px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

/* ── Receipt document ───────────────────────────────────────────────────────── */
.receipt-doc {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 150px;
  height: 190px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid color-mix(in srgb, var(--accent) 35%, transparent);
  border-radius: 8px;
  overflow: hidden;
  box-shadow:
    0 0 24px color-mix(in srgb, var(--accent) 18%, transparent),
    0 0 80px color-mix(in srgb, var(--accent) 8%, transparent),
    inset 0 0 24px color-mix(in srgb, var(--accent) 5%, transparent);
  padding: 14px 12px 10px;
  display: flex;
  flex-direction: column;
  gap: 7px;
  backdrop-filter: blur(6px);
  z-index: 2;
}

/* Corner markers */
.receipt-corner {
  position: absolute;
  width: 11px;
  height: 11px;
  border-color: var(--accent);
  border-style: solid;
  opacity: 0.85;
  animation: cornerPulse 2.2s ease-in-out infinite;
}
.receipt-corner.tl { top:    5px; left:  5px; border-width: 2px 0 0 2px; }
.receipt-corner.tr { top:    5px; right: 5px; border-width: 2px 2px 0 0; }
.receipt-corner.bl { bottom: 5px; left:  5px; border-width: 0 0 2px 2px; }
.receipt-corner.br { bottom: 5px; right: 5px; border-width: 0 2px 2px 0; animation-delay: 0.3s; }

@keyframes cornerPulse {
  0%, 100% { opacity: 0.5; }
  50%       { opacity: 1;   filter: drop-shadow(0 0 4px var(--accent)); }
}

/* Scan beam */
.scan-line {
  position: absolute;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(
    90deg,
    transparent 0%,
    color-mix(in srgb, var(--accent) 30%, transparent) 15%,
    var(--accent) 50%,
    color-mix(in srgb, var(--accent) 30%, transparent) 85%,
    transparent 100%
  );
  box-shadow: 0 0 10px var(--accent), 0 0 28px color-mix(in srgb, var(--accent) 40%, transparent);
  animation: scanBeam 2.4s ease-in-out infinite;
  z-index: 5;
}

@keyframes scanBeam {
  0%   { top: 0%;   opacity: 0; }
  4%   { opacity: 1; }
  96%  { opacity: 1; }
  100% { top: 100%; opacity: 0; }
}

/* Fake text lines */
.doc-lines {
  display: flex;
  flex-direction: column;
  gap: 7px;
  padding-top: 2px;
}

.doc-line {
  height: 5px;
  border-radius: 3px;
  background: linear-gradient(
    90deg,
    color-mix(in srgb, var(--accent) 55%, white) 0%,
    color-mix(in srgb, var(--accent) 20%, transparent) 100%
  );
  animation: linePulse 2s ease-in-out infinite;
}

@keyframes linePulse {
  0%, 100% { opacity: 0.35; }
  50%       { opacity: 0.85; }
}

/* Amount placeholder */
.doc-amount {
  position: absolute;
  bottom: 11px;
  right: 10px;
  font-size: 10px;
  font-weight: 700;
  color: var(--accent);
  opacity: 0.75;
  letter-spacing: 0.06em;
  font-family: 'Courier New', monospace;
}

/* ── Dolphin / character arc ────────────────────────────────────────────────── */
.dolphin-x {
  position: absolute;
  top: 0;
  left: 50%;
  z-index: 3;
  animation: arcX 3.6s linear infinite;
}

.dolphin-y {
  font-size: 46px;
  display: block;
  line-height: 1;
  filter: drop-shadow(0 0 10px color-mix(in srgb, var(--accent) 65%, transparent));
  animation: arcY 3.6s ease-in-out infinite;
  transform-origin: center center;
}

/* Sailboat rocks slightly instead of tilting like a dolphin */
.dolphin-y.sailboat {
  animation: arcY-boat 3.6s ease-in-out infinite;
}

@keyframes arcX {
  0%   { transform: translateX(-135px); }
  100% { transform: translateX(135px);  }
}

@keyframes arcY {
  0%   { transform: translateY(215px) rotate(-38deg); opacity: 0; }
  7%   { opacity: 1; }
  50%  { transform: translateY(10px)  rotate(0deg);  opacity: 1; }
  93%  { opacity: 1; }
  100% { transform: translateY(215px) rotate(38deg);  opacity: 0; }
}

/* Sailboat: gentler arc, stays more upright, slight rock */
@keyframes arcY-boat {
  0%   { transform: translateY(215px) rotate(-12deg); opacity: 0; }
  7%   { opacity: 1; }
  30%  { transform: translateY(60px)  rotate(-5deg);  opacity: 1; }
  50%  { transform: translateY(20px)  rotate(0deg);   opacity: 1; }
  70%  { transform: translateY(60px)  rotate(5deg);   opacity: 1; }
  93%  { opacity: 1; }
  100% { transform: translateY(215px) rotate(12deg);  opacity: 0; }
}

/* ── Step pill ──────────────────────────────────────────────────────────────── */
.step-pill {
  display: flex;
  align-items: center;
  gap: 10px;
  background: color-mix(in srgb, var(--accent) 10%, rgba(0,0,0,0.3));
  border: 1px solid color-mix(in srgb, var(--accent) 30%, transparent);
  border-radius: 100px;
  padding: 10px 24px;
  backdrop-filter: blur(10px);
  box-shadow: 0 0 20px color-mix(in srgb, var(--accent) 12%, transparent),
              inset 0 1px 0 rgba(255, 255, 255, 0.06);
  min-width: 230px;
  justify-content: center;
  animation: pillIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes pillIn {
  from { opacity: 0; transform: scale(0.9) translateY(6px); }
  to   { opacity: 1; transform: scale(1)   translateY(0);   }
}

.step-pill-icon { font-size: 18px; }

.step-pill-text {
  font-size: 15px;
  font-weight: 600;
  color: color-mix(in srgb, var(--accent) 90%, white);
  letter-spacing: 0.02em;
}

/* ── Progress dots ──────────────────────────────────────────────────────────── */
.step-dots {
  display: flex;
  gap: 8px;
  align-items: center;
}

.step-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.08);
  transition: all 0.3s ease;
}

.step-dot.done {
  background: rgba(0, 200, 100, 0.45);
  border-color: rgba(0, 230, 120, 0.55);
}

.step-dot.active {
  background: var(--accent);
  border-color: var(--accent);
  box-shadow: 0 0 10px var(--accent);
  transform: scale(1.4);
  opacity: 0.9;
}

/* ── Joke card ──────────────────────────────────────────────────────────────── */
.joke-card {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.09);
  border-radius: 14px;
  padding: 16px 20px;
  max-width: 420px;
  backdrop-filter: blur(12px);
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.25);
  animation: jokeIn 0.65s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes jokeIn {
  from { opacity: 0; transform: translateY(24px) scale(0.94); }
  to   { opacity: 1; transform: translateY(0)    scale(1);    }
}

.joke-label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  color: color-mix(in srgb, var(--accent) 75%, white);
  margin-bottom: 9px;
}

.joke-text {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.82);
  line-height: 1.65;
  margin: 0;
  font-style: italic;
}

/* ── Ocean waves ────────────────────────────────────────────────────────────── */
.ocean {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 90px;
  pointer-events: none;
}

.wave {
  position: absolute;
  bottom: 0;
  width: 200%;
  left: -50%;
  border-radius: 50% 50% 0 0;
}

.wave1 { height: 56px; background: var(--wave1); animation: waveAnim 7s   ease-in-out infinite; }
.wave2 { height: 44px; background: var(--wave2); animation: waveAnim 9s   ease-in-out infinite reverse; animation-delay: -3s; }
.wave3 { height: 30px; background: var(--wave3); animation: waveAnim 5.5s ease-in-out infinite; animation-delay: -5s; }

@keyframes waveAnim {
  0%, 100% { transform: translateX(-4%) scaleY(1);    }
  50%       { transform: translateX(4%)  scaleY(1.08); }
}

/* Wildevaart: faster, choppier waves */
.rapids .wave1 { animation-duration: 2.8s; height: 62px; }
.rapids .wave2 { animation-duration: 2.1s; }
.rapids .wave3 { animation-duration: 1.6s; }

@keyframes waveAnimRapid {
  0%   { transform: translateX(-6%) scaleY(1);    }
  25%  { transform: translateX(3%)  scaleY(1.15); }
  50%  { transform: translateX(-3%) scaleY(0.95); }
  75%  { transform: translateX(5%)  scaleY(1.12); }
  100% { transform: translateX(-6%) scaleY(1);    }
}

.rapids .wave1 { animation-name: waveAnimRapid; }
.rapids .wave2 { animation-name: waveAnimRapid; }
.rapids .wave3 { animation-name: waveAnimRapid; }

/* ── Responsive ─────────────────────────────────────────────────────────────── */
@media (max-width: 768px) {
  .scene        { width: 210px; height: 215px; }
  .receipt-doc  { width: 126px; height: 162px; }
  .dolphin-y    { font-size: 38px; }
  .step-pill    { min-width: 190px; padding: 9px 18px; }
  .step-pill-text { font-size: 13px; }
  .joke-card    { padding: 13px 16px; }
  .joke-text    { font-size: 13px; }
}
`, "",{"version":3,"sources":["webpack://./src/components/AILoadingAnimation.css"],"names":[],"mappings":"AAAA;;;mFAGmF;;AAEnF,kFAAkF;AAClF;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,oEAAoE;EACpE,oBAAoB;AACtB;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA,kFAAkF;AAClF;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,4BAA4B;EAC5B,sCAAsC;EACtC,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,OAAO,sCAAsC,IAAI,YAAY,EAAE;EAC/D,OAAO,wCAAwC,EAAE,YAAY,EAAE;EAC/D,OAAO,wCAAwC,EAAE,UAAU,IAAI;AACjE;;AAEA,kFAAkF;AAClF;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,wBAAwB;EACxB,gBAAgB;EAChB,WAAW;AACb;;AAEA,kFAAkF;AAClF;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA,kFAAkF;AAClF;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,oEAAoE;EACpE,kBAAkB;EAClB,gBAAgB;EAChB;;;oEAGkE;EAClE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,0BAA0B;EAC1B,UAAU;AACZ;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,gDAAgD;AAClD;AACA,qBAAqB,WAAW,EAAE,UAAU,EAAE,yBAAyB,EAAE;AACzE,qBAAqB,WAAW,EAAE,UAAU,EAAE,yBAAyB,EAAE;AACzE,qBAAqB,WAAW,EAAE,UAAU,EAAE,yBAAyB,EAAE;AACzE,qBAAqB,WAAW,EAAE,UAAU,EAAE,yBAAyB,EAAE,qBAAqB,EAAE;;AAEhG;EACE,WAAW,YAAY,EAAE;EACzB,YAAY,UAAU,IAAI,0CAA0C,EAAE;AACxE;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX;;;;;;;GAOC;EACD,+FAA+F;EAC/F,6CAA6C;EAC7C,UAAU;AACZ;;AAEA;EACE,OAAO,OAAO,IAAI,UAAU,EAAE;EAC9B,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;EACnB,OAAO,SAAS,EAAE,UAAU,EAAE;AAChC;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB;;;;GAIC;EACD,4CAA4C;AAC9C;;AAEA;EACE,WAAW,aAAa,EAAE;EAC1B,YAAY,aAAa,EAAE;AAC7B;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA,kFAAkF;AAClF;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,gFAAgF;EAChF,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA,8DAA8D;AAC9D;EACE,8CAA8C;AAChD;;AAEA;EACE,OAAO,6BAA6B,EAAE;EACtC,OAAO,4BAA4B,GAAG;AACxC;;AAEA;EACE,OAAO,2CAA2C,EAAE,UAAU,EAAE;EAChE,OAAO,UAAU,EAAE;EACnB,OAAO,yCAAyC,GAAG,UAAU,EAAE;EAC/D,OAAO,UAAU,EAAE;EACnB,OAAO,0CAA0C,GAAG,UAAU,EAAE;AAClE;;AAEA,2DAA2D;AAC3D;EACE,OAAO,2CAA2C,EAAE,UAAU,EAAE;EAChE,OAAO,UAAU,EAAE;EACnB,OAAO,0CAA0C,GAAG,UAAU,EAAE;EAChE,OAAO,yCAAyC,IAAI,UAAU,EAAE;EAChE,OAAO,yCAAyC,IAAI,UAAU,EAAE;EAChE,OAAO,UAAU,EAAE;EACnB,OAAO,0CAA0C,GAAG,UAAU,EAAE;AAClE;;AAEA,kFAAkF;AAClF;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kEAAkE;EAClE,oEAAoE;EACpE,oBAAoB;EACpB,kBAAkB;EAClB,2BAA2B;EAC3B;qDACmD;EACnD,gBAAgB;EAChB,uBAAuB;EACvB,wDAAwD;AAC1D;;AAEA;EACE,OAAO,UAAU,EAAE,qCAAqC,EAAE;EAC1D,OAAO,UAAU,EAAE,mCAAmC,IAAI;AAC5D;;AAEA,kBAAkB,eAAe,EAAE;;AAEnC;EACE,eAAe;EACf,gBAAgB;EAChB,mDAAmD;EACnD,sBAAsB;AACxB;;AAEA,kFAAkF;AAClF;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,kCAAkC;EAClC,qBAAqB;EACrB,YAAY;AACd;;AAEA,kFAAkF;AAClF;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,0CAA0C;EAC1C,yDAAyD;AAC3D;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,OAAO,UAAU,EAAE,oCAAoC,KAAK;AAC9D;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,mDAAmD;EACnD,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,iBAAiB;EACjB,SAAS;EACT,kBAAkB;AACpB;;AAEA,kFAAkF;AAClF;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,0BAA0B;AAC5B;;AAEA,SAAS,YAAY,EAAE,wBAAwB,EAAE,6CAA6C,EAAE;AAChG,SAAS,YAAY,EAAE,wBAAwB,EAAE,qDAAqD,EAAE,oBAAoB,EAAE;AAC9H,SAAS,YAAY,EAAE,wBAAwB,EAAE,6CAA6C,EAAE,oBAAoB,EAAE;;AAEtH;EACE,WAAW,oCAAoC,KAAK;EACpD,YAAY,uCAAuC,EAAE;AACvD;;AAEA,uCAAuC;AACvC,iBAAiB,wBAAwB,EAAE,YAAY,EAAE;AACzD,iBAAiB,wBAAwB,EAAE;AAC3C,iBAAiB,wBAAwB,EAAE;;AAE3C;EACE,OAAO,oCAAoC,KAAK;EAChD,OAAO,uCAAuC,EAAE;EAChD,OAAO,uCAAuC,EAAE;EAChD,OAAO,uCAAuC,EAAE;EAChD,OAAO,oCAAoC,KAAK;AAClD;;AAEA,iBAAiB,6BAA6B,EAAE;AAChD,iBAAiB,6BAA6B,EAAE;AAChD,iBAAiB,6BAA6B,EAAE;;AAEhD,kFAAkF;AAClF;EACE,gBAAgB,YAAY,EAAE,aAAa,EAAE;EAC7C,gBAAgB,YAAY,EAAE,aAAa,EAAE;EAC7C,gBAAgB,eAAe,EAAE;EACjC,gBAAgB,gBAAgB,EAAE,iBAAiB,EAAE;EACrD,kBAAkB,eAAe,EAAE;EACnC,gBAAgB,kBAAkB,EAAE;EACpC,gBAAgB,eAAe,EAAE;AACnC","sourcesContent":["/* ══════════════════════════════════════════════════════════════════════════════\n   AI Loading Animation\n   Colors driven by CSS custom properties set per group in the component.\n   ══════════════════════════════════════════════════════════════════════════════ */\n\n/* ── Overlay ────────────────────────────────────────────────────────────────── */\n.ai-loading-overlay {\n  position: fixed;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  overflow: hidden;\n  animation: overlayIn 0.4s ease-out;\n}\n\n/* Central glow */\n.ai-loading-overlay::before {\n  content: '';\n  position: absolute;\n  top: 30%;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 520px;\n  height: 520px;\n  background: radial-gradient(circle, var(--glow) 0%, transparent 70%);\n  pointer-events: none;\n}\n\n@keyframes overlayIn {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n/* ── Floating bubbles ───────────────────────────────────────────────────────── */\n.bubble {\n  position: absolute;\n  bottom: -20px;\n  border-radius: 50%;\n  background: var(--bubble-bg);\n  border: 1px solid var(--bubble-border);\n  animation: bubbleRise linear infinite;\n  pointer-events: none;\n}\n\n@keyframes bubbleRise {\n  0%   { transform: translateY(0)      scale(1);   opacity: 0.7; }\n  40%  { transform: translateY(-35vh)  scale(1.1); opacity: 0.4; }\n  100% { transform: translateY(-100vh) scale(0.7); opacity: 0;   }\n}\n\n/* ── Main container ─────────────────────────────────────────────────────────── */\n.ai-loading-container {\n  position: relative;\n  z-index: 10;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n  padding: 20px 24px 110px;\n  max-width: 460px;\n  width: 100%;\n}\n\n/* ── Scene ──────────────────────────────────────────────────────────────────── */\n.scene {\n  position: relative;\n  width: 260px;\n  height: 260px;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n}\n\n/* ── Receipt document ───────────────────────────────────────────────────────── */\n.receipt-doc {\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 150px;\n  height: 190px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid color-mix(in srgb, var(--accent) 35%, transparent);\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow:\n    0 0 24px color-mix(in srgb, var(--accent) 18%, transparent),\n    0 0 80px color-mix(in srgb, var(--accent) 8%, transparent),\n    inset 0 0 24px color-mix(in srgb, var(--accent) 5%, transparent);\n  padding: 14px 12px 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n  backdrop-filter: blur(6px);\n  z-index: 2;\n}\n\n/* Corner markers */\n.receipt-corner {\n  position: absolute;\n  width: 11px;\n  height: 11px;\n  border-color: var(--accent);\n  border-style: solid;\n  opacity: 0.85;\n  animation: cornerPulse 2.2s ease-in-out infinite;\n}\n.receipt-corner.tl { top:    5px; left:  5px; border-width: 2px 0 0 2px; }\n.receipt-corner.tr { top:    5px; right: 5px; border-width: 2px 2px 0 0; }\n.receipt-corner.bl { bottom: 5px; left:  5px; border-width: 0 0 2px 2px; }\n.receipt-corner.br { bottom: 5px; right: 5px; border-width: 0 2px 2px 0; animation-delay: 0.3s; }\n\n@keyframes cornerPulse {\n  0%, 100% { opacity: 0.5; }\n  50%       { opacity: 1;   filter: drop-shadow(0 0 4px var(--accent)); }\n}\n\n/* Scan beam */\n.scan-line {\n  position: absolute;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: linear-gradient(\n    90deg,\n    transparent 0%,\n    color-mix(in srgb, var(--accent) 30%, transparent) 15%,\n    var(--accent) 50%,\n    color-mix(in srgb, var(--accent) 30%, transparent) 85%,\n    transparent 100%\n  );\n  box-shadow: 0 0 10px var(--accent), 0 0 28px color-mix(in srgb, var(--accent) 40%, transparent);\n  animation: scanBeam 2.4s ease-in-out infinite;\n  z-index: 5;\n}\n\n@keyframes scanBeam {\n  0%   { top: 0%;   opacity: 0; }\n  4%   { opacity: 1; }\n  96%  { opacity: 1; }\n  100% { top: 100%; opacity: 0; }\n}\n\n/* Fake text lines */\n.doc-lines {\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n  padding-top: 2px;\n}\n\n.doc-line {\n  height: 5px;\n  border-radius: 3px;\n  background: linear-gradient(\n    90deg,\n    color-mix(in srgb, var(--accent) 55%, white) 0%,\n    color-mix(in srgb, var(--accent) 20%, transparent) 100%\n  );\n  animation: linePulse 2s ease-in-out infinite;\n}\n\n@keyframes linePulse {\n  0%, 100% { opacity: 0.35; }\n  50%       { opacity: 0.85; }\n}\n\n/* Amount placeholder */\n.doc-amount {\n  position: absolute;\n  bottom: 11px;\n  right: 10px;\n  font-size: 10px;\n  font-weight: 700;\n  color: var(--accent);\n  opacity: 0.75;\n  letter-spacing: 0.06em;\n  font-family: 'Courier New', monospace;\n}\n\n/* ── Dolphin / character arc ────────────────────────────────────────────────── */\n.dolphin-x {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  z-index: 3;\n  animation: arcX 3.6s linear infinite;\n}\n\n.dolphin-y {\n  font-size: 46px;\n  display: block;\n  line-height: 1;\n  filter: drop-shadow(0 0 10px color-mix(in srgb, var(--accent) 65%, transparent));\n  animation: arcY 3.6s ease-in-out infinite;\n  transform-origin: center center;\n}\n\n/* Sailboat rocks slightly instead of tilting like a dolphin */\n.dolphin-y.sailboat {\n  animation: arcY-boat 3.6s ease-in-out infinite;\n}\n\n@keyframes arcX {\n  0%   { transform: translateX(-135px); }\n  100% { transform: translateX(135px);  }\n}\n\n@keyframes arcY {\n  0%   { transform: translateY(215px) rotate(-38deg); opacity: 0; }\n  7%   { opacity: 1; }\n  50%  { transform: translateY(10px)  rotate(0deg);  opacity: 1; }\n  93%  { opacity: 1; }\n  100% { transform: translateY(215px) rotate(38deg);  opacity: 0; }\n}\n\n/* Sailboat: gentler arc, stays more upright, slight rock */\n@keyframes arcY-boat {\n  0%   { transform: translateY(215px) rotate(-12deg); opacity: 0; }\n  7%   { opacity: 1; }\n  30%  { transform: translateY(60px)  rotate(-5deg);  opacity: 1; }\n  50%  { transform: translateY(20px)  rotate(0deg);   opacity: 1; }\n  70%  { transform: translateY(60px)  rotate(5deg);   opacity: 1; }\n  93%  { opacity: 1; }\n  100% { transform: translateY(215px) rotate(12deg);  opacity: 0; }\n}\n\n/* ── Step pill ──────────────────────────────────────────────────────────────── */\n.step-pill {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: color-mix(in srgb, var(--accent) 10%, rgba(0,0,0,0.3));\n  border: 1px solid color-mix(in srgb, var(--accent) 30%, transparent);\n  border-radius: 100px;\n  padding: 10px 24px;\n  backdrop-filter: blur(10px);\n  box-shadow: 0 0 20px color-mix(in srgb, var(--accent) 12%, transparent),\n              inset 0 1px 0 rgba(255, 255, 255, 0.06);\n  min-width: 230px;\n  justify-content: center;\n  animation: pillIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n@keyframes pillIn {\n  from { opacity: 0; transform: scale(0.9) translateY(6px); }\n  to   { opacity: 1; transform: scale(1)   translateY(0);   }\n}\n\n.step-pill-icon { font-size: 18px; }\n\n.step-pill-text {\n  font-size: 15px;\n  font-weight: 600;\n  color: color-mix(in srgb, var(--accent) 90%, white);\n  letter-spacing: 0.02em;\n}\n\n/* ── Progress dots ──────────────────────────────────────────────────────────── */\n.step-dots {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.step-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.12);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  transition: all 0.3s ease;\n}\n\n.step-dot.done {\n  background: rgba(0, 200, 100, 0.45);\n  border-color: rgba(0, 230, 120, 0.55);\n}\n\n.step-dot.active {\n  background: var(--accent);\n  border-color: var(--accent);\n  box-shadow: 0 0 10px var(--accent);\n  transform: scale(1.4);\n  opacity: 0.9;\n}\n\n/* ── Joke card ──────────────────────────────────────────────────────────────── */\n.joke-card {\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.09);\n  border-radius: 14px;\n  padding: 16px 20px;\n  max-width: 420px;\n  backdrop-filter: blur(12px);\n  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.25);\n  animation: jokeIn 0.65s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n@keyframes jokeIn {\n  from { opacity: 0; transform: translateY(24px) scale(0.94); }\n  to   { opacity: 1; transform: translateY(0)    scale(1);    }\n}\n\n.joke-label {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n  color: color-mix(in srgb, var(--accent) 75%, white);\n  margin-bottom: 9px;\n}\n\n.joke-text {\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.82);\n  line-height: 1.65;\n  margin: 0;\n  font-style: italic;\n}\n\n/* ── Ocean waves ────────────────────────────────────────────────────────────── */\n.ocean {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 90px;\n  pointer-events: none;\n}\n\n.wave {\n  position: absolute;\n  bottom: 0;\n  width: 200%;\n  left: -50%;\n  border-radius: 50% 50% 0 0;\n}\n\n.wave1 { height: 56px; background: var(--wave1); animation: waveAnim 7s   ease-in-out infinite; }\n.wave2 { height: 44px; background: var(--wave2); animation: waveAnim 9s   ease-in-out infinite reverse; animation-delay: -3s; }\n.wave3 { height: 30px; background: var(--wave3); animation: waveAnim 5.5s ease-in-out infinite; animation-delay: -5s; }\n\n@keyframes waveAnim {\n  0%, 100% { transform: translateX(-4%) scaleY(1);    }\n  50%       { transform: translateX(4%)  scaleY(1.08); }\n}\n\n/* Wildevaart: faster, choppier waves */\n.rapids .wave1 { animation-duration: 2.8s; height: 62px; }\n.rapids .wave2 { animation-duration: 2.1s; }\n.rapids .wave3 { animation-duration: 1.6s; }\n\n@keyframes waveAnimRapid {\n  0%   { transform: translateX(-6%) scaleY(1);    }\n  25%  { transform: translateX(3%)  scaleY(1.15); }\n  50%  { transform: translateX(-3%) scaleY(0.95); }\n  75%  { transform: translateX(5%)  scaleY(1.12); }\n  100% { transform: translateX(-6%) scaleY(1);    }\n}\n\n.rapids .wave1 { animation-name: waveAnimRapid; }\n.rapids .wave2 { animation-name: waveAnimRapid; }\n.rapids .wave3 { animation-name: waveAnimRapid; }\n\n/* ── Responsive ─────────────────────────────────────────────────────────────── */\n@media (max-width: 768px) {\n  .scene        { width: 210px; height: 215px; }\n  .receipt-doc  { width: 126px; height: 162px; }\n  .dolphin-y    { font-size: 38px; }\n  .step-pill    { min-width: 190px; padding: 9px 18px; }\n  .step-pill-text { font-size: 13px; }\n  .joke-card    { padding: 13px 16px; }\n  .joke-text    { font-size: 13px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
